import { Immutable } from "immer";
import React from "react";

import { reverse, templates } from "@reactivated";

import { ProductCompareTheme } from "../../../constants";
import { isoWebPageURL } from "../../../models/nominals";
import {
    ICompareTile,
    ProductCompareGridCMSData,
    ProductCompareGridColumnCardCMSData,
    isoTileID,
} from "../../../models/product-compare";
import { check } from "../../../models/utils";
import { useAppSelector, useSSRStorePrefill } from "../../../store/reducers";
import { usePageURL } from "../../../utils/urls";
import { ProductCompareGrid } from "../ProductCompareGrid";
import { ProductCompareGrid__ColumnCard } from "../ProductCompareGrid__ColumnCard";
import { defaults } from "../defaults";
import { prefillProductCompareTiles } from "../ssr";

type IProps = Immutable<templates.ProductCompareGridBlockTemplate> & {
    showFirstAvailablePrice?: boolean;
    isMinimal?: boolean;
};

export const ProductCompareGridSSR = (props: IProps): React.JSX.Element => {
    useSSRStorePrefill(
        {
            base_tiles_data: props.base_tiles_data,
            products_by_id_data: props.products_by_id_data,
        },
        prefillProductCompareTiles,
    );

    const allTiles = useAppSelector(
        (s) => (s.productcompare || defaults).tiles,
    );

    const tiles: readonly ICompareTile[] =
        props.initial_compare_tile_ids.length > 0
            ? allTiles.filter((tile) =>
                  props.initial_compare_tile_ids.includes(
                      isoTileID.unwrap(tile.product_compare_tile.id),
                  ),
              )
            : allTiles;

    const financeLink = usePageURL("finance_link");
    const home = usePageURL("home");

    if (props.variant === "column-card") {
        const cms = check(
            ProductCompareGridColumnCardCMSData.decode(
                JSON.parse(props.cms_data),
            ),
        );
        return (
            <ProductCompareGrid__ColumnCard
                header={cms.header}
                basketLink={isoWebPageURL.wrap(reverse("basket:summary"))}
                financingLink={financeLink || home}
                tiles={tiles}
                sizeAttributeOptionGroup={cms.size_attribute_option_group}
                preselectedSize={cms.preselected_size}
                returnUrl={props.return_url}
            />
        );
    }

    const cms = check(
        ProductCompareGridCMSData.decode(JSON.parse(props.cms_data)),
    );
    return (
        <ProductCompareGrid
            header={cms.header}
            basketLink={isoWebPageURL.wrap(reverse("basket:summary"))}
            financingLink={financeLink || home}
            tiles={tiles}
            sizeAttributeOptionGroup={cms.size_attribute_option_group}
            preselectedSize={cms.preselected_size}
            theme={cms.theme.theme || ProductCompareTheme.DEFAULT}
            showFirstAvailablePrice={props.showFirstAvailablePrice}
            isMinimal={props.isMinimal}
            returnUrl={props.return_url}
        />
    );
};
